import { Link, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { DetailPretAccorde } from '@/api/types';
import { Chargement, ErreurBloc, PageHeader } from '@/components/common';
import { PretAccorde } from './PretAccorde';

/** Prêt accordé sans demande dans l'application (repris du classeur) : vue du portefeuille par identifiant de prêt. */
export function PretAccordePage() {
  const { id } = useParams();
  const { data, isLoading, error } = useQuery({ queryKey: ['rh', 'pret-accorde-id', id], queryFn: () => api<DetailPretAccorde>(`/rh/portefeuille/${id}`), enabled: Boolean(id) });
  if (isLoading) return <Chargement />;
  if (error || !data) return <ErreurBloc erreur={error} />;
  if (data.pret.demandeId) return <PretDemandeRedirection demandeId={data.pret.demandeId} />;
  return (
    <div>
      <PageHeader
        titre={`Prêt ${data.pret.numero}`}
        sousTitre={`${data.pret.libelleNature} · ${data.pret.agent.nom} · ${data.pret.structure.libelle}${data.pret.origine === 'REPRISE' ? ' · repris du classeur de suivi' : ''}`}
        retour={
          <Link to="/rh/portefeuille" className="text-sm text-muted-foreground hover:underline">
            ← Portefeuille des prêts
          </Link>
        }
      />
      <PretAccordeSansDemande id={data.pret.id} />
    </div>
  );
}

function PretDemandeRedirection({ demandeId }: { demandeId: string }) {
  return (
    <div className="p-6 text-sm">
      Ce prêt est rattaché à une demande :{' '}
      <Link to={`/rh/prets/${demandeId}?onglet=remboursement`} className="text-primary hover:underline">
        ouvrir le dossier
      </Link>
      .
    </div>
  );
}

/** Le composant PretAccorde lit le prêt par sa demande ; pour un prêt repris, on passe par l'identifiant de prêt. */
function PretAccordeSansDemande({ id }: { id: string }) {
  return <PretAccorde demandeId={id} parPretId />;
}
